// extracted by mini-css-extract-plugin
export default {"content":"Error_content__EpNVj"};